import React, { useState, useEffect } from 'react';
import { Box, styled, Typography, Dialog, DialogTitle, DialogContent, DialogActions, Button, IconButton } from '@mui/material';
// import DashBoardLink from '../../dashbaordLink/DashboardLink';
import { Link } from 'react-router-dom';
import { useLocation } from 'react-router-dom';
import SettingsIcon from '../../../assets/Settings.svg';
import LogoutIcon from '../../../assets/LogoutIcon.svg';
import DashboardCustomizeSharpIcon from '@mui/icons-material/DashboardCustomizeSharp';
import AddCircleSharpIcon from '@mui/icons-material/AddCircleSharp';
import PhoneBook from '../../../assets/Phonebook.svg';
import PhoneImg from '../../../assets/contactUsWhite.svg';
import Message from '../../../assets/Message.svg';
import Welcome from '../../../assets/party.png';
import Joyride from 'react-joyride';
import CloseIcon from '@mui/icons-material/Close';
import { userLSAuth } from '../../../components/app/features/env';
import { useDispatch, useSelector } from 'react-redux';
import { endtour } from '../../../components/app/features/message/messageSlice';
import { getUserProfile } from '../../../components/app/features/auth/AuthSlice';

const SidebarWrapper = styled(Box)(
   ({ theme }) => `
          width: ${theme.sidebar.minWidth};
          padding-top:  ${theme.header.height};
          min-width: ${theme.sidebar.minWidth};
          background: ${theme.sidebar.background};
          position: fixed;
          top: 0;
          z-index: 7;
          bottom:0;
          left:0;
         transition: width 0.1s ease-in-out;
         transition: transform 0.1s ease-in-out;
         display:flex;
         flex-direction: column;
         justify-content: space-between;
         row-gap:2rem;
         @media (max-width: ${theme.breakpoints.values.myCustomQueryI}px) {
           display: none;
        }
								
  `
);

const boxSX = {
   py: '12px',
   pl: '22px',
   mt: '10px',
   color: '#ffffff',
   cursor: 'pointer',
   borderLeft: '4px solid #7A88C0',
   '&:hover': {
      color: '#ffffff',
      backgroundColor: '#2E4085',
      borderLeft: '5px solid white',
   },
};
const activeLink = {
   py: '12px',
   pl: '22px',
   mt: '17px',
   cursor: 'pointer',
   color: '#ffffff',
   backgroundColor: '#2E4085',
   borderLeft: '4px solid white',
};

const Sidebar = ({ isOpen, getLogOutState }) => {
   const location = useLocation();
   const [runTour, setRunTour] = useState(false);
   const [showStartDialog, setShowStartDialog] = useState(false);
   const currentUser = userLSAuth();
   const showAppIntro = useSelector((state) => state.auth.showAppIntro);
   const dispatch = useDispatch();

   // Check user onboarding status on component mount
   useEffect(() => {
      // If user is logged in and showAppIntro is true, show the dialog
      if ( showAppIntro) {
         
         setShowStartDialog(true);
      }
   }, [showAppIntro]);

   // Use useEffect to watch for changes in showAppIntro
   useEffect(() => {
      if (showAppIntro === false) {
         setRunTour(false);
         setShowStartDialog(false);
      }
   }, [showAppIntro]);

   const steps = [
      {
         target: '[data-tour="dashboard"]',
         content: 'Get an overview of your SMS unit balance, recent messages, app updates and quick actions.',
         disableBeacon: true,
         placement: 'right',
         offset: 20,
         title: 'Your control center'
      },
      {
         target: '[data-tour="send-message"]',
         content: 'Craft your messages, select recipients, and send in just a few taps. Simple, fast, and effective.',
         disableBeacon: true,
         placement: 'right',
         offset: 20,
         title: 'Send SMS in seconds'
      },
      {
         target: '[data-tour="top-up"]',
         content: 'Easily top up your wallet to keep your messages flowing. Multiple payment options available.',
         disableBeacon: true,
         placement: 'right',
         offset: 20,
         title: 'Never run out of SMS units'
      },
      {
         target: '[data-tour="contacts"]',
         content: 'Save, organize, and group your contacts—or import them in bulk via CSV or VCF for seamless messaging.',
         disableBeacon: true,
         placement: 'right',
         offset: 20,
         title: 'Import & manage your contacts'
      },

      {
         target: '[data-tour="settings"]',
         content: 'Apply for your Sender ID, update profile details, and tweak preferences to suit your needs.',
         disableBeacon: true,
         placement: 'right',
         offset: 20,
         title: 'Customize your experience'
      },


   ];

   const handleStartTour = () => {
     
      setShowStartDialog(false);
      if (showAppIntro) {
         setRunTour(true);
      }
   };

   const handleCloseDialog = () => {
     
     
      const userId = currentUser?.id;
      if (userId) {
         dispatch(endtour(userId)).then(() => {
            
           
            setShowStartDialog(false)
            dispatch(getUserProfile())
         });
      }
   };
   // dispatch(endtour(206))

   return (
      <SidebarWrapper
         sx={{
            width: isOpen ? '250px' : '100px',
         }}
      >
         {/* Get Started Dialog */}
        
         <Dialog
   open={showStartDialog}
   onClose={() => setShowStartDialog(false)}
   maxWidth="xs"
   fullWidth
>
               <IconButton
                  onClick={handleCloseDialog}
                  sx={{
                     position: 'absolute',
                     right: 8,
                     top: 8
                  }}
               >
                  <CloseIcon />
               </IconButton>
               <img
                  src={Welcome}
                  alt="welcome"
                  style={{
                     maxWidth: '100%',
                     height: 'auto',
                     maxHeight: '200px',
                     objectFit: 'contain',
                     marginTop: '3rem'
                  }}
               />

               <DialogTitle variant="h6" sx={{ fontWeight: 600, fontSize: '1.7rem', color: '#333333', textAlign: 'center' }}  >
                  Welcome to Parrotica!
               </DialogTitle>
               <DialogContent>
                  <Typography variant="h6" sx={{ fontWeight: 400, fontSize: '1.1rem', color: '#333333', textAlign: 'center' }}>
                     Your all-in-one platform for seamless bulk messaging. Let's show you around!
                  </Typography>
               </DialogContent>
               <DialogActions sx={{ justifyContent: 'center', pb: 2 }}>
                  <Button
                     onClick={handleStartTour}
                     variant="contained"
                     color="primary"
                     sx={{
                        fontSize: '1rem',
                        marginBottom: '2rem',
                        backgroundColor: '#0040BF',
                        color: '#fff',
                        borderRadius: 1,
                        px: 4,
                        '&:hover': {
                           backgroundColor: '#0040cF',
                        },
                     }}
                  >
                     Get Started
                  </Button>
               </DialogActions>
            </Dialog>
         



         <Box>
            <Link
               to="/dashboard"
               style={{
                  textDecoration: 'none',
               }}
               data-tour="dashboard"
            >
               <Box
                  display="flex"
                  textAlign="center"
                  alignItems="center"
                  gap={1}
                  sx={location.pathname == '/dashboard' ? activeLink : boxSX}
               >
                  <DashboardCustomizeSharpIcon
                     sx={{
                        fontSize: '35px',
                        marginLeft: '-7px',
                     }}
                  />
                  <Typography variant="h5" fontSize="16px" fontWeight={500}>
                     {isOpen === true ? 'Dashboard' : ''}
                  </Typography>
               </Box>
            </Link>
            <Link
               to="/send-message"
               style={{
                  textDecoration: 'none',
               }}
               data-tour="send-message"
            >
               <Box
                  display="flex"
                  textAlign="center"
                  alignItems="center"
                  gap={1.3}
                  sx={
                     location.pathname.includes('send-message')
                        ? activeLink
                        : boxSX
                  }
               >
                  <img
                     src={Message}
                     alt="message"
                     style={{
                        width: '30px',
                        marginLeft: '-7px',
                     }}
                  />
                  <Typography variant="h5" fontSize="16px" fontWeight={500}>
                     {isOpen ? 'Send Message' : ''}
                  </Typography>
               </Box>
            </Link>
            <Link
               to="/top-up"
               style={{
                  textDecoration: 'none',
               }}
               data-tour="top-up"
            >
               <Box
                  display="flex"
                  textAlign="center"
                  alignItems="center"
                  gap={1}
                  sx={location.pathname.includes('top-up') ? activeLink : boxSX}
               >
                  <AddCircleSharpIcon
                     sx={{
                        fontSize: '38px',
                        ml: '-7px',
                     }}
                  />
                  <Typography variant="h5" fontSize="16px" fontWeight={500}>
                     {isOpen ? 'Top-Up' : ''}
                  </Typography>
               </Box>
            </Link>
            <Link
               to="/contacts"
               style={{
                  textDecoration: 'none',
               }}
               data-tour="contacts"
            >
               <Box
                  display="flex"
                  textAlign="center"
                  alignItems="center"
                  gap={1.4}
                  sx={
                     location.pathname.includes('contacts') ? activeLink : boxSX
                  }
               >
                  <img src={PhoneBook} style={{ width: '30px' }} alt="Phone" />
                  <Typography variant="h5" fontSize="16px" fontWeight={500}>
                     {isOpen ? 'Contacts' : ''}
                  </Typography>
               </Box>
            </Link>
         </Box>
         {/* <DashBoardLink isOpen={isOpen} /> */}
         <Box>
            <Link
               to="/dashboard/contact"
               style={{
                  textDecoration: 'none',
               }}
               data-tour="contact-support"
            >
               {runTour && (
                  <Joyride
                     steps={steps}
                     run={runTour}
                     continuous={true}
                     showSkipButton={true}
                     showProgress={false}
                     disableOverlayClose={true}
                     disableBeacon={true}
                     disableScrolling={true}
                     styles={{
                        options: {
                           primaryColor: '#0040BF',
                           zIndex: 10000,
                           backgroundColor: '#fff',
                           overlayColor: 'rgba(0, 0, 0, 0.5)',
                           arrowColor: '#ffffff',
                           width: 800,
                           transitionDuration: 0
                        },
                        tooltip: {
                           padding: '32px',
                           borderRadius: '8px',
                           boxShadow: '0 2px 15px rgba(0, 0, 0, 0.1)',
                           backgroundColor: '#ffffff',
                           maxWidth: '800px',
                        },
                        tooltipContainer: {
                           textAlign: 'left',
                           backgroundColor: '#ffffff',
                        },
                        tooltipTitle: {
                           fontSize: '24px',
                           fontWeight: '600',
                           marginBottom: '16px',
                           color: '#333',
                        },
                        tooltipContent: {
                           fontSize: '16px',
                           lineHeight: 1.6,
                           color: '#555',
                           marginBottom: '32px',
                        },
                        buttonNext: {
                           backgroundColor: '#0040BF',
                           color: 'white',
                           padding: '12px 24px',
                           fontSize: '16px',
                           borderRadius: '4px',
                           fontWeight: '500',
                           cursor: 'pointer',
                           transition: 'all 0.2s ease',
                           '&:hover': {
                              backgroundColor: '#0033a0'
                           }
                        },
                        buttonBack: {
                           color: '#666',
                           padding: '12px 0',
                           fontSize: '16px',
                           marginRight: '20px',
                           backgroundColor: 'transparent',
                           cursor: 'pointer',
                           transition: 'all 0.2s ease',
                           '&:hover': {
                              color: '#333'
                           }
                        },
                        buttonSkip: {
                           color: '#777',
                           fontSize: '16px',
                           fontWeight: '400',
                           position: 'absolute',
                           right: '32px',
                           top: '32px',
                           cursor: 'pointer',
                           transition: 'all 0.2s ease',
                           '&:hover': {
                              color: '#333'
                           }
                        },
                     }}
                     locale={{
                        last: 'Finish',
                        skip: 'skip',
                        next: 'Next',
                        back: 'Previous',
                     }}
                     floaterProps={{
                        disableAnimation: true,
                        hideArrow: false,
                        placement: 'right',
                        offset: 20,
                        styles: {
                           arrow: {
                              color: '#ffffff',
                              length: 16,
                              spread: 16,
                           },
                           floater: {
                              filter: 'drop-shadow(0 2px 5px rgba(0, 0, 0, 0.1))',
                           },
                        },
                     }}
                     tooltipComponent={({
                        continuous,
                        index,
                        size,
                        step,
                        backProps,
                        closeProps,
                        primaryProps,
                        tooltipProps,
                        isLastStep,
                        skipProps
                     }) => (
                        <div {...tooltipProps} style={{
                           padding: '32px',
                           borderRadius: '8px',
                           backgroundColor: '#ffffff',
                           width: '100%',
                           minWidth: '500px',
                           maxWidth: '800px',
                        }}>
                           <button {...skipProps} style={{
                              background: 'none',
                              border: 'none',
                              position: 'absolute',
                              right: '32px',
                              top: '32px',
                              color: '#777',
                              cursor: 'pointer',
                              fontSize: '16px',
                              transition: 'color 0.2s ease'
                           }}
                              onMouseEnter={(e) => e.target.style.color = '#333'}
                              onMouseLeave={(e) => e.target.style.color = '#777'}
                           >
                              Skip
                           </button>
                           <h2 style={{
                              margin: '0 0 16px 0',
                              fontSize: '24px',
                              fontWeight: '600',
                              color: '#333'
                           }}>
                              {step.title || 'Your control center'}
                           </h2>
                           <div style={{
                              margin: '0 0 32px 0',
                              fontSize: '16px',
                              lineHeight: 1.6,
                              color: '#555'
                           }}>
                              {step.content}
                           </div>
                           <div style={{
                              display: 'flex',
                              justifyContent: 'space-between',
                              alignItems: 'center'
                           }}>
                              <div>
                                 {index > 0 && (
                                    <button
                                       {...backProps}
                                       style={{
                                          background: 'none',
                                          border: 'none',
                                          color: '#666',
                                          padding: '12px 0',
                                          fontSize: '16px',
                                          marginRight: '20px',
                                          cursor: 'pointer',
                                          transition: 'color 0.2s ease'
                                       }}
                                       onMouseEnter={(e) => e.target.style.color = '#333'}
                                       onMouseLeave={(e) => e.target.style.color = '#666'}
                                    >
                                       Previous
                                    </button>
                                 )}
                                 <button
                                    {...primaryProps}
                                    style={{
                                       backgroundColor: '#0040BF',
                                       color: 'white',
                                       padding: '12px 24px',
                                       fontSize: '16px',
                                       borderRadius: '4px',
                                       fontWeight: '500',
                                       border: 'none',
                                       cursor: 'pointer',
                                       transition: 'background-color 0.2s ease'
                                    }}
                                    onMouseEnter={(e) => e.target.style.backgroundColor = '#0033a0'}
                                    onMouseLeave={(e) => e.target.style.backgroundColor = '#0040BF'}
                                 >
                                    {isLastStep ? 'Finish' : 'Next'}
                                 </button>
                              </div>
                              <div style={{
                                 fontSize: '16px',
                                 color: '#666'
                              }}>
                                 {index + 1} of {size}
                              </div>
                           </div>
                        </div>
                     )}
                     callback={(data) => {
                        if (data.status === 'finished' || data.status === 'skipped') {
                         
                           const userId = currentUser?.id;
                           if (userId) {
                              setRunTour(false);
                              setShowStartDialog(false);
                              handleCloseDialog()
                             
                             
                             
                           }
                        }
                     }}
                  />
               )}
               <Box
                  display="flex"
                  textAlign="center"
                  alignItems="center"
                  gap={1.4}
                  sx={
                     location.pathname.includes('dashboard/contact')
                        ? activeLink
                        : boxSX
                  }
               >
                  <img
                     src={PhoneImg}
                     alt="Phone"
                     style={{
                        marginLeft: '-7px',
                        width: '30px',
                     }}
                  />
                  <Typography variant="h5" fontSize="16px" fontWeight={500}>
                     {isOpen ? 'Contact Support' : ''}
                  </Typography>
               </Box>
            </Link>
            <Link
               to="/settings"
               style={{
                  textDecoration: 'none',
               }}
               data-tour="settings"
            >
               <Box>
                  <Box
                     display="flex"
                     textAlign="center"
                     alignItems="center"
                     gap={1.3}
                     sx={location.pathname == '/settings' ? activeLink : boxSX}
                  >
                     <img
                        src={SettingsIcon}
                        alt="message"
                        style={{
                           marginLeft: '-7px',
                           width: '30px',
                        }}
                     />
                     <Typography variant="h5" fontSize="16px" fontWeight={500}>
                        {isOpen ? 'Settings' : ''}
                     </Typography>
                  </Box>
               </Box>
            </Link>

            <Box
               display="flex"
               textAlign="center"
               alignItems="center"
               gap={1.3}
               sx={boxSX}
               onClick={() => {
                  getLogOutState(true);
               }}
            >
               <img
                  src={LogoutIcon}
                  alt="message"
                  style={{
                     marginLeft: '-7px',
                     width: '30px',
                  }}
               />
               <Typography variant="h5" fontSize="16px" fontWeight={500}>
                  {isOpen ? 'Log out' : ''}
               </Typography>
            </Box>
         </Box>

      </SidebarWrapper>
   );
};

export default Sidebar;
